import { act } from "react";
import { CapitalizeFirstWord } from "../../helpers/CustomFileUpoader";

// Auth Reducer Types
interface AuthState {
  isLoggedIn: boolean;
  role?: any;
  user?: any; // You can replace `any` with a more specific type if available
  clockIn?: any;
  location?: string;
  clockInData?: any;
}

interface AuthLoadSuccessAction {
  type: "AUTH_LOAD_SUCCESS";
  payload: any; // Replace `any` with the actual user data type if available
}

interface AuthLoadFailureAction {
  type: "AUTH_LOAD_FAILURE";
}

interface AuthLoginSuccessAction {
  type: "AUTH_LOGIN_SUCCESS";
  payload: any;
}

interface AuthLogoutSuccessAction {
  type: "AUTH_LOGOUT_SUCCESS";
}

interface LoginSuccessAction {
  type: "LOGIN_SUCCESS";
  payload: any; // Replace `any` with the actual user data type if available
}

interface LogoutSuccessAction {
  type: "LOGOUT_SUCCESS";
}
interface AuthCheckinOut {
  type: "AUTH_CLOCK_IN_STATUS";
  payload: any;
}
interface AUTH_CLOCK_IN {
  type: "AUTH_CLOCK_IN";
  payload: any;
}
interface AUTH_CLOCK_OUT {
  type: "AUTH_CLOCK_OUT";
  payload: any;
}

interface AUTH_CHANGE_LOCATION {
  type: "AUTH_CHANGE_LOCATION";
  payload: any;
}
interface PROFILE_ADD_TEAM_MEMBER_DATA {
  type: "PROFILE_ADD_TEAM_MEMBER_DATA";
  payload: any;
}
interface PROFILE_UPDTAE_MEMBER_DATA {
  type: "PROFILE_UPDTAE_MEMBER_DATA";
  payload: any;
}
interface PROFILE_DELETE_TEAM_MEMEBR {
  type: "PROFILE_DELETE_TEAM_MEMEBR";
  payload: any;
}

type AuthAction =
  | AuthLoadSuccessAction
  | AuthLoadFailureAction
  | AuthLoginSuccessAction
  | AuthLogoutSuccessAction
  | LoginSuccessAction
  | LogoutSuccessAction
  | AuthCheckinOut
  | AUTH_CLOCK_IN
  | AUTH_CLOCK_OUT
  | AUTH_CHANGE_LOCATION
  | PROFILE_ADD_TEAM_MEMBER_DATA
  | PROFILE_UPDTAE_MEMBER_DATA
  | PROFILE_DELETE_TEAM_MEMEBR;

export const authReducer = (
  state: AuthState = {
    isLoggedIn: false,
    role: undefined,
    user: undefined,
    clockIn: undefined,
    location: "",
    clockInData: undefined,
  },
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case "AUTH_LOAD_SUCCESS":
      return {
        ...state,
        role: action.payload.role_id,
        isLoggedIn: true,
        user: action.payload,
      };
    case "AUTH_LOAD_FAILURE":
      return {
        ...state,
        isLoggedIn: false,
        role: -1,
      };
    case "AUTH_LOGIN_SUCCESS":
      return {
        ...state,
        role: action.payload.role_id,
        isLoggedIn: true,
      };
    case "AUTH_LOGOUT_SUCCESS":
      return {
        ...state,
        isLoggedIn: false,
        user: undefined,
        role: -1,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
      };

    case "LOGOUT_SUCCESS":
      return {
        ...state,
        user: undefined,
        isLoggedIn: false,
        role: -1,
      };
    case "AUTH_CLOCK_IN_STATUS":
      return {
        ...state,
        clockIn: action.payload?.data ? true : false,
        location: action.payload?.data?.location ? action.payload?.data?.location : "",
        clockInData: action.payload?.data ? action.payload?.data : undefined,
      };
    case "AUTH_CLOCK_IN":
      return {
        ...state,
        clockIn: action.payload?.data ? true : false,
        location: action.payload?.data?.location ? action.payload?.data?.location : "",
        clockInData: action.payload?.data ? action.payload?.data : undefined,
      };
    case "AUTH_CLOCK_OUT":
      return {
        ...state,
        clockIn: false,
        location: "",
        clockInData: undefined,
      };
    case "AUTH_CHANGE_LOCATION":
      return {
        ...state,
        location: action.payload?.location,
        clockInData: action?.payload,
      };

    case "PROFILE_UPDTAE_MEMBER_DATA":
      const updatedTeamMeber = state?.user?.team_members?.map((elem: any) => {
        if (elem?._id == action?.payload?._id) {
          return {
            ...action?.payload,
            full_name: `${CapitalizeFirstWord(action?.payload?.first_name)} ${CapitalizeFirstWord(action?.payload?.last_name)}`,
          };
        }
        return elem;
      });
      return {
        ...state,
        user: { ...state?.user, team_members: updatedTeamMeber },
      };

    case "PROFILE_ADD_TEAM_MEMBER_DATA":
      const addedTeamMember = [
        ...state?.user?.team_members,
        {
          ...action?.payload,
          full_name: `${CapitalizeFirstWord(action?.payload?.first_name)} ${CapitalizeFirstWord(action?.payload?.last_name)}`,
        },
      ];
      return {
        ...state,
        user: { ...state?.user, team_members: addedTeamMember },
      };

    case "PROFILE_DELETE_TEAM_MEMEBR":
      const deletedTeamMeber = state?.user?.team_members?.filter((elem: any) => elem?._id != action?.payload);
      return {
        ...state,
        user: { ...state?.user, team_members: deletedTeamMeber },
      };

    default:
      return state;
  }
};
